import { useState, useEffect, useContext } from 'react';
import {ErrorContext} from '../Contexts/ErrorContext'
import DocumentService from '../Services/DocumentService';
import FileService from '../Services/FileService';
import {extractErrorMessage} from '../Services/RequestService';

export const useVehicleDocuments = (vehicleId) => {
    const [documents, setDocuments] = useState([]);
    const token = localStorage.getItem("token");
    const {setError, success} = useContext(ErrorContext);

    const loadAll = async () => {
        try {
            const resp = await DocumentService.allDocuments(token, vehicleId);
            setDocuments(resp.data);
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const addVehicleDocuments = async (vehicle) => {
        try {
            await DocumentService.addDocument(token, vehicle);
            await loadAll()
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const getVehicleDocumentFile = async (fileId, shouldResponseBeBlob) => {
        try {
            return await FileService.getFile(token, fileId, shouldResponseBeBlob);
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const editVehicleDocument = async (document) => {
        try {
            await DocumentService.editDocument(token, document);
            await loadAll()
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const deleteVehicleDocument = async (document) => {
        try {
            await DocumentService.deleteDocument(token, document.id);
            await loadAll()
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    useEffect(() => {
        loadAll()
    }, []);

    return [documents, addVehicleDocuments, getVehicleDocumentFile, editVehicleDocument, deleteVehicleDocument];
}


// WEBPACK FOOTER //
// ./src/Hooks/useVehicleDocuments.js